import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Lazy load translations only when needed
const loadTranslation = (lang) => {
  // Fix: Map "EN" or "ENGLISH" to "en" to load en.json instead of english.json
  const normalized = lang.toLowerCase();
  const fileName = normalized === 'english' ? 'en' : normalized;
  return import(`./locales/${fileName}.json`);
};

// Initialize with minimal resources
const resources = {
  EN: { translation: {} },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'EN',
    lng: localStorage.getItem('selectedLanguage') || 'EN',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

// Load initial language
const initialLang = localStorage.getItem('selectedLanguage') || 'EN';
loadTranslation(initialLang).then((translation) => {
  i18n.addResourceBundle(initialLang, 'translation', translation.default, true, true);
  i18n.changeLanguage(initialLang);
});

// Load translation when language changes
i18n.on('languageChanged', (lng) => {
  if (!i18n.hasResourceBundle(lng, 'translation')) {
    loadTranslation(lng).then((translation) => {
      i18n.addResourceBundle(lng, 'translation', translation.default, true, true);
    });
  }
});

export default i18n;

